import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PackOperatorParameters} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"
import {GeometryPackOperatorNode, packOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"

export type PointGeometryPackOperatorParameters = PackOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryPackOperatorParameters> = {
    nodeClass: "PointGeometryPackOperator",
    validation: {
        parameters: packOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryPackOperator extends GeometryPackOperatorNode<0, PointGeometryAttributeLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
